var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflineStorageAssurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 201,
    viewBox: "0 0 400 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_5415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.617188H400V200.617H0V0.617188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 176.617H116",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 192.617C383 151.196 349.421 117.617 308 117.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 80.6172C120 71.7806 127.163 64.6172 136 64.6172H292C300.837 64.6172 308 71.7806 308 80.6172V176.617H120V80.6172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 180.617C14 97.7745 81.1573 30.6172 164 30.6172",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 176.617,
    r: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8594 70.6012C83.8594 80.7076 75.6665 88.9006 65.5601 88.9006C55.4536 88.9006 47.2607 80.7076 47.2607 70.6012C47.2607 60.4947 55.4536 52.3018 65.5601 52.3018C75.6665 52.3018 83.8594 60.4947 83.8594 70.6012Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9828 77.5871C65.639 77.5871 66.2416 77.8224 66.7149 78.2151L64.9828 80.4136L63.2506 78.2151C63.7239 77.8224 64.3265 77.5871 64.9828 77.5871ZM56.5382 61.9414L72.7777 78.5963L71.4785 79.9286L66.7201 75.0473C66.1739 74.8614 65.5898 74.7607 64.9828 74.7607C63.6708 74.7607 62.4658 75.2308 61.5194 76.0158L60.3652 74.5496C61.5374 73.5776 63.0069 72.9677 64.6119 72.8858L62.227 70.4401C60.8972 70.8258 59.6789 71.4837 58.6328 72.3513L57.4782 70.8855C58.4598 70.0713 59.5697 69.4135 60.7719 68.9488L58.6731 66.795C57.6232 67.3076 56.6419 67.9441 55.7472 68.6861L54.5923 67.2205C55.432 66.524 56.3396 65.9101 57.3033 65.3909L55.239 63.2738L56.5382 61.9414ZM67.2797 70.3189L65.1816 68.168L64.9827 68.1657C67.8256 68.1657 70.4366 69.1846 72.4874 70.8856L71.3326 72.3513C70.1673 71.3847 68.7884 70.6786 67.2797 70.3189ZM64.9828 63.455C68.919 63.455 72.5339 64.8656 75.3734 67.2207L74.2182 68.6861C71.6944 66.5929 68.4813 65.3393 64.9828 65.3393C64.1761 65.3393 63.3846 65.406 62.6133 65.5342L61.055 63.9363C62.314 63.6218 63.6293 63.455 64.9828 63.455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 28.6172C146 19.7806 153.163 12.6172 162 12.6172L266 12.6172C274.837 12.6172 282 19.7806 282 28.6172L282 176.617L146 176.617L146 28.6172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 176.617H164C164 149.003 186.386 126.617 214 126.617C241.614 126.617 264 149.003 264 176.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 180.617C102 187.245 107.373 192.617 114 192.617H314C320.627 192.617 326 187.245 326 180.617V176.617H102V180.617Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 184.617H234",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166,
    cy: 32.6172,
    rx: 4,
    ry: 4.00001,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 32.6172,
    rx: 4,
    ry: 4.00001,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 52.6172H242",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 62.6172H202",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 111L370 104.617L398 113.934V130.206C398 147.732 386.685 163.254 370 168.617C355.08 163.821 347.664 147.1 354.125 132.822L364 111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 104.617L364 111L354.125 132.822C347.664 147.1 355.08 163.821 370 168.617V168.617V168.617C386.685 163.254 398 147.732 398 130.206V113.934L370 104.617ZM370 104.617L342 113.934L336.5 120.5",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 119.934L364 110.617L392 119.934V136.206C392 153.732 380.685 169.254 364 174.617C347.315 169.254 336 153.732 336 136.206V119.934Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 144.91L366.746 126.617L365.518 139.056H373L361.835 156.617L363.063 144.91H355Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.907 93.6172L214.907 165.617M214.907 165.617L232.567 148.683M214.907 165.617L196.567 148.683",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_5415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "white",
    transform: "translate(0 0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineStorageAssurance);
export default __webpack_public_path__ + "static/media/offline_storage_assurance.3be51f4caccb0bb4e2a462425cfa0860.svg";
export { ForwardRef as ReactComponent };